export default {

  /**
   * Group into groups of four
   * @param unGroupedData
   * @returns {[]}
   */
  group(unGroupedData) {
    let grouped = [];
    let index = -1;
    for (let i = 0; i < unGroupedData.length; i++) {
      if (i % 4 === 0) {
        index++;
        grouped[index] = [];
      }
      grouped[index].push(unGroupedData[i]);
    }
    return grouped;
  },

  /**
   * Sort by Id
   * @param unSortedData
   * @returns sorted data
   */
  sortById(unSortedData) {
    return unSortedData.sort(this.compareById);
  },

  /**
   * Compare by Id
   * @param a
   * @param b
   * @returns {number}
   */
  compareById(a, b) {
    return a.id - b.id
  },

  /**
   * Find item in list where the slug matches the given slug
   * @param slug
   * @param searchData
   * @returns matched item
   */
  findBySlug(slug, searchData) {
    for (let i = 0; i < searchData.length; i++) {
      if (searchData[i].slug === slug) {
        return searchData[i]
      }
    }
  }
};
